export const nonprofitAuthRouteNames = [
  'nonprofitLogin', 'nonprofitSignup', 'nonprofitChoice', 'nonprofitJoin',
  'nonprofitPendingApproval', 'nonprofitOnboarding',
  'nonprofitForgotPassword', 'nonprofitForgotPasswordSuccess',
]
